import React from 'react';
import { makeStyles, Box } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  list: {
    marginTop: theme.spacing(1.5),
    padding: 0,
    listStyle: 'none',
  },
  item: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    padding: theme.spacing(0.75, 0),
    borderBottom: `1px dashed ${theme.palette.divider}`,
    '&:last-child': {
      borderBottom: 'none',
    },
  },
  icon: {
    color: theme.palette.text.disabled,
    fontSize: '1rem',
    display: 'flex',
    alignItems: 'center',
  },
  content: {
    flex: 1,
  },
  value: {
    marginLeft: 'auto',
    display: 'flex',
    alignItems: 'center',
    gap: 4
  }
}));

export const SKList = ({ children, className = '', ...props }) => {
  const classes = useStyles();
  return (
    <ul className={`${classes.list} ${className}`} {...props}>
      {children}
    </ul>
  );
};

export const SKListItem = ({ icon, label, value, children, className = '', ...props }) => {
  const classes = useStyles();
  return (
    <li className={`${classes.item} ${className}`} {...props}>
      {icon && <span className={classes.icon}>{icon}</span>}
      <div className={classes.content}>
        {label}
      </div>
      <div className={classes.value}>
        {value || children}
      </div>
    </li>
  );
};
